<app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="batch">
      <span class="batch__heading"
        >Batch {{ screenType === "create" ? "Creation" : "" }}</span
      >
      <div class="batch__batchData">
        <div class="batch__batchData__block">
          <div
            class="batch__batchData__block__firstRow batch__batchData__block__firstRow--bigElement"
          >
            <span>Batch Name</span>
            <input
              [ngClass]="error && batchName['invalid'] ? 'batch__error' : ''"
              [formControl]="batchName"
              *ngIf="screenType !== 'update'"
            />
            <input
              [ngClass]="error && batchName['invalid'] ? 'batch__error' : ''"
              [formControl]="batchName"
              *ngIf="screenType === 'update'"
              [disabled]="true"
            />
          </div>
          <div
            class="batch__batchData__block__firstRow batch__batchData__block__firstRow--bigElement"
          >
            <span>Course</span>
            <mat-select
              [(value)]="selectedCourse"
              (selectionChange)="selectCourse()"
              [ngClass]="
                error && courseList['length'] === 0 ? 'batch__error' : ''
              "
            >
              <mat-option
                *ngFor="let course of courses"
                [value]="course.courseId"
                >{{ course.courseName }}</mat-option
              >
            </mat-select>
          </div>
          <div class="batch__batchData__block__firstRow">
            <span>Start Date</span>
            <div
              class="batch__batchData__block__date"
              [ngClass]="error && startDate['invalid'] ? 'batch__error' : ''"
            >
              <input
                matInput
                class="batch__batchData__block__date__input"
                [matDatepicker]="startDatePicker"
                [max]="endDate['value']"
                [formControl]="startDate"
                readonly
                (click)="startDatePicker.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </div>
          </div>
          <div class="batch__batchData__block__firstRow">
            <span>End Date</span>
            <div
              class="batch__batchData__block__date"
              [ngClass]="error && endDate['invalid'] ? 'batch__error' : ''"
            >
              <input
                matInput
                class="batch__batchData__block__date__input"
                [matDatepicker]="endDatePicker"
                [min]="startDate['value']"
                [formControl]="endDate"
                readonly
                (click)="endDatePicker.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="endDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </div>
          </div>
        </div>
        <div class="batch__batchData__selectedCourse">
          <span class="batch__batchData__selectedCourse__heading">
            Selected Courses
          </span>
          <ng-container *ngFor="let course of courseList; index as courseIndex">
            <span class="batch__batchData__selectedCourse__name">
              <mat-icon
                class="batch__batchData__selectedCourse__name__close"
                (click)="removeCourse(courseIndex)"
                >cancel</mat-icon
              >
              {{ course.courseName }}</span
            >
          </ng-container>
        </div>
        <ng-container
          *ngFor="let day of schedules['controls']; index as dayIndex"
        >
          <div class="batch__batchData__block batch__batchData__block--day">
            <div>
              <span>Active</span>
              <mat-checkbox
                [checked]="getFormControl(dayIndex, 'isDisabled').value === 1"
                (change)="onCheckboxToggle($event.checked, dayIndex)"
              >
              </mat-checkbox>
            </div>

            <div>
              <span>Type</span>
              <!-- <mat-select
                [formControl]="
                  schedules['controls'][dayIndex]['controls']['type']
                "
                [ngClass]="
                  error &&
                  schedules['controls'][dayIndex]['controls']['type']['invalid']
                    ? 'batch__error'
                    : ''
                "
              >
                <mat-option [value]="1">In-Person</mat-option>
                <mat-option [value]="2">Live Online</mat-option>
                <mat-option [value]="3">Hybrid (In-Person & Online)</mat-option>
              </mat-select> -->
              <mat-select
                [formControl]="getFormControl(dayIndex, 'type')"
                [ngClass]="
                  error && getFormControl(dayIndex, 'type')['invalid']
                    ? 'batch__error'
                    : ''
                "
              >
                <mat-option [value]="1">In-Person</mat-option>
                <mat-option [value]="2">Live Online</mat-option>
                <mat-option [value]="3">Hybrid (In-Person & Online)</mat-option>
              </mat-select>
            </div>
            <div>
              <span>Subject</span>
              <mat-select
                [formControl]="getFormControl(dayIndex, 'subject')"
                [ngClass]="
                  error && getFormControl(dayIndex, 'subject')['invalid']
                    ? 'batch__error'
                    : ''
                "
              >
                <mat-option [value]="1">Math</mat-option>
                <mat-option [value]="2">English</mat-option>
                <mat-option [value]="3">Math and English</mat-option>
                <mat-option [value]="4">Science</mat-option>
              </mat-select>
            </div>
            <div>
              <span>Tutor</span>
              <mat-select
                [formControl]="getFormControl(dayIndex, 'tutor')"
                [ngClass]="
                  error && getFormControl(dayIndex, 'tutor')['invalid']
                    ? 'batch__error'
                    : ''
                "
              >
                <div *ngFor="let tutor of tutors; index as tutorIndex">
                  <mat-option [value]="tutor['tutorName']">{{
                    tutor["tutorName"]
                  }}</mat-option>
                </div>
              </mat-select>
            </div>
            <div>
              <span>Day</span>
              <mat-select
                [formControl]="getFormControl(dayIndex, 'day')"
                [ngClass]="
                  error && getFormControl(dayIndex, 'day')['invalid']
                    ? 'batch__error'
                    : ''
                "
              >
                <mat-option [value]="1">Monday</mat-option>
                <mat-option [value]="2">Tuesday</mat-option>
                <mat-option [value]="3">Wednesday</mat-option>
                <mat-option [value]="4">Thursday</mat-option>
                <mat-option [value]="5">Friday</mat-option>
                <mat-option [value]="6">Saturday</mat-option>
                <mat-option [value]="7">Sunday</mat-option>
              </mat-select>
            </div>
            <div class="batch__batchData__block--day__time">
              <span>Start Time</span>
              <!-- <p-calendar
                [timeOnly]="true"
                [readonlyInput]="true"
                hourFormat="12"
              ></p-calendar> -->
              <!-- <input
                [ngxTimepicker]="startTimePicker"
                [formControl]="
                  getFormControl(dayIndex,'startTime')
                "
                [max]="
                  getFormControl(dayIndex,'endTime')[
                    'value'
                  ]
                    ? getFormControl(dayIndex,'endTime')[
                        'value'
                      ]
                    : '11:59 PM'
                "
                [ngClass]="
                  error &&
                  getFormControl(dayIndex,'startTime')[
                    'invalid'
                  ]
                    ? 'batch__error'
                    : ''
                "
                readonly
              />
              <ngx-material-timepicker
                #startTimePicker
              ></ngx-material-timepicker> -->
              <input
                [ngxMatTimepicker]="startTimePicker"
                [formControl]="getFormControl(dayIndex, 'startTime')"
                [max]="
                  getFormControl(dayIndex, 'endTime')['value']
                    ? getFormControl(dayIndex, 'endTime')['value']
                    : '11:59 PM'
                "
                [ngClass]="
                  error && getFormControl(dayIndex, 'startTime')['invalid']
                    ? 'batch__error'
                    : ''
                "
                readonly
              />
              <ngx-mat-timepicker #startTimePicker></ngx-mat-timepicker>
            </div>
            <div class="batch__batchData__block--day__time">
              <span>End Time</span>
              <input
                [ngxMatTimepicker]="endTimePicker"
                [formControl]="getFormControl(dayIndex, 'endTime')"
                [min]="
                  getFormControl(dayIndex, 'startTime')['value']
                    ? getFormControl(dayIndex, 'startTime')['value']
                    : '12:00 AM'
                "
                [ngClass]="
                  error && getFormControl(dayIndex, 'endTime')['invalid']
                    ? 'batch__error'
                    : ''
                "
                readonly
              />
              <ngx-mat-timepicker #endTimePicker></ngx-mat-timepicker>
            </div>
            <div>
              <span>Time Zone</span>
              <mat-select
                [formControl]="getFormControl(dayIndex, 'timeZone')"
                [ngClass]="
                  error && getFormControl(dayIndex, 'timeZone')['invalid']
                    ? 'batch__error'
                    : ''
                "
              >
                <mat-option [value]="1">Eastern Time</mat-option>
                <mat-option [value]="2">Center Time</mat-option>
                <mat-option [value]="3">Mountain Time</mat-option>
                <mat-option [value]="4">Pacific Time</mat-option>
                <mat-option [value]="5">Indian Time</mat-option>
              </mat-select>
            </div>
            <div>
              <span
                >Class URL
                <img
                  src="assets/join.png"
                  alt="Join Class"
                  class="join-button"
                  *ngIf="getFormControl(dayIndex, 'classUrl').value"
                  (click)="openUrl(getFormControl(dayIndex, 'classUrl').value)"
                />
              </span>
              <input
                [formControl]="getFormControl(dayIndex, 'classUrl')"
                [ngClass]="
                  error && getFormControl(dayIndex, 'classUrl')['invalid']
                    ? 'batch__error'
                    : ''
                "
              />
            </div>

            <div>
              <span></span>
              <button
                class="batch__batchData__block--day__add"
                [ngClass]="
                  dayIndex > 0
                    ? 'batch__batchData__block--day__add--remove'
                    : ''
                "
                (click)="
                  dayIndex === 0 ? addNewSchedule() : removeSchedule(dayIndex)
                "
              >
                <mat-icon>{{ dayIndex === 0 ? "add" : "remove" }}</mat-icon>
                {{ dayIndex === 0 ? "Add" : "Remove" }}
              </button>
            </div>
          </div>
        </ng-container>
        <div *ngIf="screenType === 'update'" class="batch__batchData__students">
          <div class="batch__batchData__students__addBlock">
            <span class="batch__batchData__students__addBlock__add"
              >Add Student</span
            >
            <!-- <mat-select-autocomplete
              class="batch__batchData__students__addBlock__search capitalize"
              [selectedOptions]="defaultSelectedStudents"
              (selectionChange)="getSelectedStudents($event)"
              [multiple]="true"
              [display]="'studentName'"
              [value]="'student_id'"
              [placeholder]="'Ex: John'"
              [options]="students"
              [appearance]="'outline'"
            ></mat-select-autocomplete> -->
            <p-multiSelect
              class=""
              [options]="students"
              [optionValue]="'student_id'"
              [optionLabel]="'studentName'"
              [maxSelectedLabels]="2"
              [selectedItemsLabel]="'{0} batches selected'"
              defaultLabel="Ex: John"
              [(ngModel)]="selectedStudents"
            ></p-multiSelect>
            <button
              class="button batch__batchData__students__addBlock__button"
              (click)="addStudents()"
            >
              Add Student
            </button>
          </div>
          <div class="batch__batchData__students__viewBlock">
            <span class="batch__batchData__students__viewBlock__heading"
              >Selected Students</span
            >
            <div class="batch__batchData__students__viewBlock__list">
              <ng-container
                *ngFor="let student of studentList; index as studentIndex"
              >
                <span
                  class="batch__batchData__students__viewBlock__list--item capitalize"
                >
                  <mat-icon
                    (click)="removeStudent(studentIndex)"
                    class="batch__batchData__students__viewBlock__list--item__close"
                    >close</mat-icon
                  >
                  {{ student["studentName"] }}
                </span>
              </ng-container>
            </div>
          </div>
        </div>
        <div
          class="batch__batchData__createBatch"
          *ngIf="screenType === 'create'"
        >
          <div class="batch__batchData__createBatch__checkbox">
            <mat-checkbox [(ngModel)]="isBatchActive"></mat-checkbox>
            <span>Active</span>
          </div>
          <button
            class="button"
            (click)="createOrUpdateBatch()"
            [disabled]="createOrUpdateBatchClicked"
          >
            Create Batch
          </button>
        </div>
        <div
          class="batch__batchData__updateBatch"
          *ngIf="screenType === 'update'"
        >
          <div class="batch__batchData__updateBatch__checkbox">
            <mat-checkbox [(ngModel)]="isBatchActive"></mat-checkbox>
            <span>Active</span>
          </div>
          <button
            class="button"
            (click)="createOrUpdateBatch()"
            [disabled]="createOrUpdateBatchClicked"
            [disabled]="role === '2'"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
